import startOfToday from "date-fns/startOfToday";
import endOfToday from "date-fns/endOfToday";
import startOfMonth from "date-fns/startOfMonth";
import startOfYear from "date-fns/startOfYear";
import endOfMonth from "date-fns/endOfMonth";
import endOfYear from "date-fns/endOfYear";
import subDays from "date-fns/subDays";
import subMonths from "date-fns/subMonths";

const QuickRanges: Record<
  string,
  () => {
    start: Date;
    end: Date;
  }
> = {
  Today: () => ({
    start: startOfToday(),
    end: endOfToday()
  }),
  "Last 7 Days": () => ({
    start: subDays(new Date(), 7),
    end: new Date()
  }),
  "Last 31 Days": () => ({
    start: subDays(new Date(), 31),
    end: new Date()
  }),
  "This Month": () => ({
    start: startOfMonth(new Date()),
    end: new Date()
  }),
  "Last Month": () => ({
    start: startOfMonth(subMonths(new Date(), 1)),
    end: endOfMonth(subMonths(new Date(), 1))
  }),
  "Last 12 Months": () => ({
    start: startOfMonth(subMonths(new Date(), 12)),
    end: new Date()
  }),
  "This Year": () => ({
    start: startOfYear(new Date()),
    end: new Date()
  }),
  "Last Year": () => ({
    start: startOfYear(subMonths(new Date(), 12)),
    end: endOfYear(subMonths(new Date(), 12))
  })
};

export default QuickRanges;
